import {apolloClient} from '@/setup/apollo-setup';
// import axios from "axios";
import axios from "@/setup/axios-setup";
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_STUDENTENROLL,
  GET_STUDENTENROLLS,
  GET_STUDENTENROLL_BY_FILTER,
  ADD_STUDENTENROLL,
  ADD_STUDENTENROLL_WITH_STUDENTENROLLDETAILS,
  ADD_STUDENTENROLLS_UPLOAD,
  // UPLOAD_STUDENTENROLL_SPREADSHEET,
  UPDATE_STUDENTENROLL,
  DELETE_STUDENTENROLL,
} from '@/queries/modules/student-enroll/student-enroll.js';

export async function getStudentEnrolls(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLLS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.studentEnroll;
    } else {
      context.commit('setStudentEnrolls', data.getStudentEnrolls);
      context.commit('setSuccess', null);
      return data.getStudentEnrolls
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getStudentEnrollsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLL_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentEnrolls', data.getStudentEnrollsByFilter);
      context.commit('setSuccess', null);

      return data.getStudentEnrollsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentEnroll(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLL,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.studentEnroll;
    } else {
      context.commit('setStudentEnroll', data.getStudentEnroll);
      context.commit('setSuccess', null);
      return data.getStudentEnroll
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function addStudentEnroll(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTENROLL,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const studentEnrolls = [...context.state.studentEnrolls];
      studentEnrolls.push(data.addStudentEnroll);
      context.commit('setStudentEnrolls', studentEnrolls);
      context.commit('setSuccess', newItemSuccess(data.addStudentEnroll.enrollNo));

      return data.addStudentEnroll
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentEnrollsUpload(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTENROLLS_UPLOAD,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addStudentEnrollsUpload.length));

      return data.addStudentEnrollsUpload
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentEnroll(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTENROLL,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentEnrolls.findIndex(item => item.id === data.updateStudentEnroll.id);
      const studentEnrolls = [
        ...context.state.studentEnrolls.slice(0, index),
        data.updateStudentEnroll,
        ...context.state.studentEnrolls.slice(index + 1)
      ];
      context.commit('setStudentEnrolls', studentEnrolls);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentEnroll.enrollNo));

      return data.updateStudentEnroll
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStudentEnroll(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STUDENTENROLL,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.studentEnrolls.findIndex(item => item.id === data.deleteStudentEnroll.id);
      const studentEnrolls = [
        ...context.state.studentEnrolls.slice(0, index),
        ...context.state.studentEnrolls.slice(index + 1)
      ];
      context.commit('setStudentEnrolls', studentEnrolls);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStudentEnroll.enrollNo));

      return data.deleteStudentEnroll
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentEnrollWithStudentEnrollDetails(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTENROLL_WITH_STUDENTENROLLDETAILS,
        variables: payload,
        errorPolicy: "all"
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return {status: {success: false, error: true, message: "", full: errors}}
    } else {
      context.commit('setStudentEnrolls', data.addStudentEnrollWithStudentEnrollDetails);
      context.commit('setSuccess', newItemSuccess(data.addStudentEnrollWithStudentEnrollDetails.length));

      return {
        status: {success: true, error: false, message: ""},
        data: data.addStudentEnrollWithStudentEnrollDetails
      };
    }


  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}}
  }

}

export async function uploadStudentEnrollSpreadsheet(context, payload) {
  context.commit('setProcessing', true);

  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('ext', payload.file.name.substring([payload.file.name.lastIndexOf('.') + 1]));
  formData.append('timestamp', payload.file.lastModified);
  formData.append('operationName', 'student-enroll');

  try {
    const result = await axios({
      url: 'http://localhost:8082/upload',
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: formData
    });


    const {subscribeEndPoint} = result.data;
    //:TODO change url to domain name
    // const eventSource = new EventSource(`http://localhost:8082/upload${subscribeEndPoint}`);
    const eventSource = new EventSource(`http://localhost:8082/upload${subscribeEndPoint}`);

    eventSource.onmessage = (e) => {
      if (e.lastEventId === "10") {
        eventSource.close();
      }
    };

    /*
    // Upload with Apollo and GraphQL (still not working)
    const result = await apolloClient
      .mutate({
        mutation: UPLOAD_STUDENTENROLL_SPREADSHEET,
        // variables: payload
        variables: { file }
      });
    */

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return {status: {success: false, error: true, message: "", full: errors}}
    } else {
      context.commit('setSuccess', null);
      return data;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}}
  }

}


